// Libraries
import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import { connect, Provider } from 'react-redux';
import { Router, Switch, Route } from 'react-router-dom';
import ReactGA from 'react-ga';

// Theming
import { ThemeProvider } from 'styled-components';

// Components
import configureStore from '~/redux/store/index';
//import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';
import Root from '~/components/general/root/index';

// Styles
import '~/assets/styles/index.css';

// Pages
import {
	HomePage,
	BlogPage,
	FaqsPage,
	ChallengesPage,
	ChallengesDetailsPage,
	ChallengeDetailsStandingsTable,
	ProfilePage,
	LoginPage,
	AdminChallengesPage,
	AdminChallengeDetailsPage,
	AdminNewChallenge,
	ErrorPage,
	//NotFoundPage,
} from '~/pages/index';

// History
import { history } from '~/helpers/history';

// Auth
import { authenticated, restricted } from '~/components/general/restricted/index';

// Constants
import {
	INDEX_URL,
	LOGIN_URL,
	LOGIN_ERROR_URL,
	CHALLENGES_URL,
	BLOG_URL,
	CHALLENGES_DETAILS_URL,
	CHALLENGES_DETAILS_SCORES_URL,
	SETTINGS_URL,
	CODE_REFERRAL_URL,
	ADMIN_CHALLENGES,
	ADMIN_CHALLENGES_DETAIL,
	// ADMIN_CHALLENGES_DETAIL_EDIT,
	ADMIN_CHALLENGES_NEW,
	// ADMIN_DONATIONS_AND_REWARDS,
	// ADMIN_DONATIONS_AND_REWARDS_DETAIL,
	// ADMIN_DONATIONS_AND_REWARDS_NEW,
	// ADMIN_PLAYERS,
	// ADMIN_PLAYERS_DETAIL,
	// ADMIN_PROFILE,
} from '~/data/constants/router-constants';
import { checkIsLoggedIn } from './redux/actions/authentication-actions';
import { FAQS_URL } from './data/constants/router-constants';

// Theme config
const theme = require(`sass-extract-loader?{"plugins": ["sass-extract-js"]}!./assets/styles/global/` +
	'_settings.scss');
const store = configureStore();

// Google Analytics
ReactGA.initialize('UA-78823459-2');
history.listen((location, action) => {
	ReactGA.set({ page: location.pathname });
	ReactGA.pageview(location.pathname);
});

function handleUpdate() {
	let { action } = this.state.location;

	if (action === 'PUSH') {
		window.scrollTo(0, 0);
	}
}

class App extends PureComponent {
	componentDidMount() {
		// Checks if the user is authenticated
		// This will also update the Redux store if there is an active session
		this.props.dispatch(checkIsLoggedIn());
	}
	componentDidUpdate() {
		console.log(this.props);
		// if is logged in and contactEmail === null, show popup
	}
	render() {
		return (
			<ThemeProvider theme={theme}>
				<Router onUpdate={handleUpdate} history={history}>
					<Switch>
						<Route exact path={LOGIN_URL} render={props => <LoginPage {...props} />} />
						<Route exact path={CODE_REFERRAL_URL} render={props => <LoginPage {...props} />} />
						<Route exact path={LOGIN_ERROR_URL} render={props => <ErrorPage {...props} />} />
						<Route exact path={BLOG_URL} render={props => <BlogPage {...props} />} />
						<Route exact path={FAQS_URL} render={props => <FaqsPage {...props} />} />
						<Route path={INDEX_URL}>
							<Root>
								<Switch>
									<Route exact path={INDEX_URL} render={props => <HomePage {...props} />} />
									<Route exact path={CHALLENGES_URL} render={props => <ChallengesPage {...props} />} />
									<Route exact path={CHALLENGES_DETAILS_URL} render={props => <ChallengesDetailsPage {...props} />} />
									<Route
										exact
										path={CHALLENGES_DETAILS_SCORES_URL}
										render={props => <ChallengeDetailsStandingsTable {...props} />}
									/>
									<Route
										exact
										path={SETTINGS_URL}
										render={authenticated(props => (
											<ProfilePage {...props} />
										))}
									/>
									<Route
										exact
										path={ADMIN_CHALLENGES}
										render={restricted(props => (
											<AdminChallengesPage {...props} />
										))}
									/>
									<Route
										exact
										path={ADMIN_CHALLENGES_NEW}
										render={restricted(props => (
											<AdminNewChallenge {...props} />
										))}
									/>
									<Route
										exact
										path={ADMIN_CHALLENGES_DETAIL}
										render={restricted(props => (
											<AdminChallengeDetailsPage {...props} />
										))}
									/>
									<Route render={props => <HomePage {...props} />} />
								</Switch>
							</Root>
						</Route>
					</Switch>
				</Router>
			</ThemeProvider>
		);
	}
}
function mapStateToProps(state) {
	return {
		isLoggedIn: state.authentication.isLoggedIn,
		profile: state.authentication.profile,
	};
}
const AppRedux = connect(mapStateToProps)(App);

// Render app
ReactDOM.render(
	<Provider store={store}>
		<AppRedux />
	</Provider>,
	document.getElementById('app'),
);
//registerServiceWorker();
unregister();



// WEBPACK FOOTER //
// ./src/index.js